import React from "react";

export interface SheetContentProps {
	sheetKey: string;
	[key: string]: any;
}

export interface SheetHeaderProps {
	sheetKey: string;
	[key: string]: any;
}

export const sheetRegistry: Record<
	string,
	{
		contentComponent: React.ComponentType<SheetContentProps>;
		headerComponent?: React.ComponentType<SheetHeaderProps>;
	}
> = {};

export const registerSheet = (
	id: string,
	contentComponent: React.ComponentType<SheetContentProps>,
	headerComponent?: React.ComponentType<SheetHeaderProps>
) => {
	sheetRegistry[id] = { contentComponent, headerComponent };
};
